<style scoped>

  #logo {
    width: 85px;
    height: 15px;
  }

  .ui.avatar.image {
    margin-right: 8px;
    height: 24px;
    width: 24px;
  }

</style>

<template>

  <div class="ui fixed pointing menu" :class="{ inverted: $isStaging }">

    <a v-if="$isMobile || $isSimavet()" class="item" @click="showSidebar()">
      <i class="bars large icon m-l-5"></i>
    </a>

    <a class="item" :class="{ active: isHomePage }" @click="navTo('/')">
      <img id="logo" class="ui image" src="/assets/images/top_logo.png">      
    </a>        

    <menu-item v-if="$isDesktop && $isVet()" :active="isExamRequestsPage" route="/procs/exam-requests" label="Solicitações de Exames" />
    
    <menu-item v-if="$isDesktop && !$isSimavet()" :active="isCertsPage" route="/procs/certs" label="Laudos" />

    <menu-item v-if="$isDesktop && !$isSimavet()" :active="isAnimalRegistrationsPage" route="/entries/animal-registrations" label="Fichas Cadastrais" />

    <menu-item v-if="$isDesktop" v-for="(bookmark, index) in $store.state.auth.bookmarks" :key="index"
      :active="$route.path.includes(bookmark.route)" :route="bookmark.route" :label="bookmark.label" />

    <div class="right menu"> 

      <div v-if="$isStaging" class="item animated flash">
        <div class="ui large red label m-r-10">
          Ambiente de Testes
        </div>
      </div>                     

      <div v-if="$isDesktop" class="ui simple dropdown item" :class="{ white: $isStaging }">
        <img class="ui avatar image" src="/assets/images/user.png">
        <div v-if="$store.state.auth.user" :class="userItemClass">
          {{ $store.state.auth.user.name }}<i class="dropdown icon"></i>
        </div>
        <div class="menu">
          <router-link class="item" to="/profile">
            <span :class="{ 'blue text': isProfilePage }">
              <i class="edit left icon"></i> Perfil
            </span>
          </router-link>          
          <div class="divider"></div>
          <a class="item" @click="onLogout()">
            <i class="sign out icon"></i> Sair
          </a>
        </div>
      </div>

    </div>

  </div>

</template>

<script>

  import isPageMixin from "@/mixins/ispage"  
  import MenuItem from "./menu-item.vue"

  export default {

    name: "TopMenu",

    components: {
      MenuItem,
    },

    mixins: [isPageMixin],

    mounted() {

      const width = $(window).width()

      if (width < 720) {
        this.$isMobile = true
        this.$isDesktop = false
      }    
    },

    computed: {

      userItemClass() {

        let cls = "text nowrap "

        if (this.isProfilePage) {
          cls += "blue"
        } else if (this.$isStaging) {
          cls += " white"
        } else {
          cls += " black"
        }

        return cls
      },
    },

    methods: {

      navTo(route) {        
        this.$router.push(route)
      },

      showSidebar() {
        $("#sidebar").sidebar("show")
      },

      onLogout() {
        this.$emit("onLogout")
      },    
    },

  }


</script>
